import React, {Component} from 'react'
import { Card } from './'

export default class ProductList extends Component {
  render() {
    const { products } = this.props
    return (
      <div className="list flex">
        {
          products && products.map((product, index) => (
            <Card {...product} key={index} shadow category={null} label="discover" />
          ))
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/ProductList.js